import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { LocalStorageService } from '../services/storage/local-storage.service';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
const DEFAULT_LANGUAGE_GUID = '24c9b00d-d028-4e04-a1aa-f04d2dcae2c3';

export const XAppInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes('api.doktar')) {
        return next(req);
    }

    const storage = inject(LocalStorageService);
    const modifiedRequest = req.clone({
        headers: req.headers
            .set('X-App', environment.appId)
            .set('X-Enterprise', storage.getItem<string>('enterpriseId') ?? EMPTY_GUID)
            .set('X-Auth-Token', 'Bearer ' + (storage.getItem<string>('token') ?? ''))
            .set('X-Locale', storage.getItem<string>('languageGuid') ?? DEFAULT_LANGUAGE_GUID),
    });
    return next(modifiedRequest);
};
